import { DialogUI } from '../Interface';
import { Box, Typography } from '@mui/material';

const WarningDialog = ({ handleClose, dialogData }) => {
  const { open, data } = dialogData;

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Jelzés"
      closeBtn={true}
      sx={{
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', minHeight: '200px' },
      }}
    >
      <Box my={2}>
        <Typography sx={{ fontSize: '1.6rem' }}>{data.message}</Typography>
      </Box>
    </DialogUI>
  );
};

export default WarningDialog;
